module.exports = __webpack_public_path__ + "img/v7.39e7a778.png";